/**
 *  Console helpers. The functions here are attached to `window` so
 * they can be invoked from DevTools to drive specific app states without
 * needing real device traffic. Imported once from the app entry point for
 * the side-effect binding.
 */

import awsRumActionTypes from '../consts/aws/awsRumActionTypes';
import deviceTypes from '../consts/device/deviceTypes';
import {selectCurrentHolderDusn} from '../state/selectors/iotDevices';
import {setExperienceInferenceData, updateDeviceData} from '../state/slice/iotDevices';
import {dispatch, getState} from '../state/store';
import rumCustomEvents from './events/rumCustomEvents';
import uamMappingService from './uam/uamMappingService';

const ILUMA_SWITCH_TYPE_MAP = {
    [deviceTypes.ILUMA_I2_CHARGER]: deviceTypes.ILUMA_I5_CHARGER,
    [deviceTypes.ILUMA_I2_HOLDER]: deviceTypes.ILUMA_I5_HOLDER,
    [deviceTypes.ILUMA_I5_CHARGER]: deviceTypes.ILUMA_I2_CHARGER,
    [deviceTypes.ILUMA_I5_HOLDER]: deviceTypes.ILUMA_I2_HOLDER,
};

const switchDevice = () => {
    const {deviceList} = getState().iotDevices;
    const switched = [];

    Object.values(deviceList).forEach((device) => {
        const newType = ILUMA_SWITCH_TYPE_MAP[device.type];

        if (!newType) return;

        dispatch(updateDeviceData(device.serialNumber, {type: newType}));
        switched.push({serialNumber: device.serialNumber, from: device.type, to: newType});
    });

    console.log('[switchDevice] switched devices:', switched);
    return switched;
};

const applyInference = (payload) => {
    try {
        const holderDusn = selectCurrentHolderDusn(getState());

        if (!holderDusn) {
            console.warn('[applyInference] no current holder device — connect a device first');
            return null;
        }

        const mapped = uamMappingService.experienceInferenceMapping({data: [payload]});

        dispatch(setExperienceInferenceData(holderDusn, mapped));

        console.log('[applyInference] applied', {dusn: holderDusn, mapped});
        return mapped;
    } catch (e) {
        console.error('[applyInference] error applying inference data:', e);
        return null;
    }
};

const sendNotificationReceived = (notificationName, destinationType) => {
    if (!notificationName || !destinationType) {
        console.warn('[sendNotificationReceived] notificationName and destinationType are required');
        return null;
    }

    const event = {notificationName, destinationType, action: awsRumActionTypes.RECEIVED};

    rumCustomEvents.pushPushNotification(event);

    console.log('[sendNotificationReceived] sent', event);
    return event;
};

const sendNotificationClicked = (notificationName, destinationType) => {
    if (!notificationName || !destinationType) {
        console.warn('[sendNotificationClicked] notificationName and destinationType are required');
        return null;
    }

    const event = {notificationName, destinationType, action: awsRumActionTypes.CLICK};

    rumCustomEvents.pushPushNotification(event);

    console.log('[sendNotificationClicked] sent', event);
    return event;
};

if (typeof window !== 'undefined') {
    window.switchDevice = switchDevice;
    window.applyInference = applyInference;
    window.sendNotificationReceived = sendNotificationReceived;
    window.sendNotificationClicked = sendNotificationClicked;
}

export default {
    switchDevice,
    applyInference,
    sendNotificationReceived,
    sendNotificationClicked,
};
